import {translations} from 'presentation/translations-new';
import {ChoseRightAlertMessageProps} from './types';

const {
	alert: {missingInfo, invalidInfo, invalidInfos},
} = translations['pt-br'].privateFlow.bookingFlow.confirmationDrawer;

const chooseRightAlertMessage = ({
	hasPhoneValue,
	hasEmailValue,
	isInvalidPhone,
	isInvalidEmail,
}: ChoseRightAlertMessageProps) => {
	if (!hasPhoneValue || !hasEmailValue) {
		return missingInfo;
	}
	if ((isInvalidPhone && !isInvalidEmail) || (!isInvalidPhone && isInvalidEmail)) {
		return invalidInfo;
	}
	return invalidInfos;
};

export {chooseRightAlertMessage};
